import React from "react";
import { GLOBAL_APPLICATION_INTERNAL_LINKS } from "../../../../../../links";
import { SecondaryTitle } from "../../../../../../styles/CommonStyles";
import {
  StyledCatchUpSectionWrapper,
  StyledCatchUpSectionContainer,
  StyledTextContainer,
  StyledContactUsButton,
  StyledDescription
} from "./styled";

const SecondCatchUpSection = ({ title, description, buttonText }) => {
  return (
    <StyledCatchUpSectionWrapper>
      <StyledCatchUpSectionContainer>
        <StyledTextContainer isDescription={!!description}>
          <SecondaryTitle>{title}</SecondaryTitle>
          {description && <StyledDescription>{description}</StyledDescription>}
        </StyledTextContainer>
        <StyledContactUsButton
          role="button"
          href={GLOBAL_APPLICATION_INTERNAL_LINKS.CONTACT_US}
        >
          {buttonText}
        </StyledContactUsButton>
      </StyledCatchUpSectionContainer>
    </StyledCatchUpSectionWrapper>
  );
};

export default SecondCatchUpSection;
